import React from 'react';
import PropTypes from 'prop-types';

import CompanyPanels from './CompanyPanels';
import '../../Simulator/TabBar/Results/SalesLogic/saleslogic.css';
import '../../../grid.css';
import SolarGarden from '../../../assets/solvana-solar-garden.jpg';
import { Image, Container, Left, Right } from './styles';

const Company = (props) => {
    const {
        resiToggle, provider, projectState, firstName, smartValue,
        annualResults, systemSize, inverter, includeESS,
    } = props;

    const terms = {
        provider,
        projectState,
        firstName,
        resiToggle,
        smartValue,
        annualResults,
        systemSize,
        inverter,
        includeESS,
    };

    return (
        <Container>
            <Left>
                <Image alt="solvana solar array" src={SolarGarden} />
            </Left>
            <Right>
                <h2>Who We Are</h2>
                <CompanyPanels terms={terms} />
            </Right>
        </Container>
    );
};

Company.propTypes = {
    resiToggle: PropTypes.bool.isRequired,
    includeESS: PropTypes.bool.isRequired,
    annualResults: PropTypes.object.isRequired,
    provider: PropTypes.number.isRequired,
    projectState: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    smartValue: PropTypes.number.isRequired,
    systemSize: PropTypes.number.isRequired,
    inverter: PropTypes.string.isRequired,
};

export default Company;



// WEBPACK FOOTER //
// ./src/containers/Home/Company/Company.js